import { render, staticRenderFns } from "./MyRatings.vue?vue&type=template&id=560945f6&scoped=true&"
import script from "./MyRatings.vue?vue&type=script&lang=js&"
export * from "./MyRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560945f6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/MyRatings.vue
// module id = 573
// module chunks = 6